const map = {
	"./aiDevelopment/aiDevelopmentProjects.menu.js": 7441,
	"./aiDevelopment/aiDevelopmentStories.menu.js": 3030,
	"./aiDevelopment/aiGlobalExecutionSettings.menu.js": 6498,
	"./aiDevelopment/aiSprintBoard.menu.js": 436,
	"./documentation/businessRules.menu.js": 18,
	"./documentation/userManual.menu.js": 3944,
	"./legacy/activities.menu.js": 2893,
	"./legacy/addresses.menu.js": 5690,
	"./legacy/commissionSalesGroups.menu.js": 3511,
	"./legacy/companyInfo.menu.js": 3799,
	"./legacy/contacts.menu.js": 1249,
	"./legacy/counties.menu.js": 5600,
	"./legacy/countries.menu.js": 1472,
	"./legacy/customerItemEquivalences.menu.js": 5260,
	"./legacy/customers.menu.js": 317,
	"./legacy/deliveryModes.menu.js": 5774,
	"./legacy/items.menu.js": 6946,
	"./legacy/paymentSchedules.menu.js": 7222,
	"./legacy/salesAudit.menu.js": 8435,
	"./legacy/salesOrderInboundMessages.menu.js": 4185,
	"./legacy/salesorder.menu.js": 2478,
	"./legacy/seleccionBobinasPvs.menu.js": 1060,
	"./legacy/states.menu.js": 7664,
	"./legacy/taxTable.menu.js": 5947,
	"./legacy/webNews.menu.js": 3669,
	"./legacy/zipCodes.menu.js": 6195,
	"./system/alertDefinitions.menu.js": 2780,
	"./system/auditEvents.menu.js": 4794
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3290;